<template>
  <div
    class="modal fade"
    id="eventInfo"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content" v-if="event">
        <div class="modal-header">
          <div class="event__type" :style="{background: getBgColor}">
            <span>{{ event.type }}</span>
          </div>
          <div
            class="event__type"
            :style="{background: getBgColor}"
          >{{ event.start_time | formatDay }} - {{ event.start_time | formatDate }} - {{ event.end_time | formatDate }}</div>
          <div class="btn btn-outline-secondary">
            <span v-if="$route.params.language === 'pt'">Sala: {{ event.room.name_pt }}</span>
            <span v-if="$route.params.language === 'en'">Room: {{ event.room.name_en }}</span>
            <span v-if="$route.params.language === 'es'">Sala: {{ event.room.name_es }}</span>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div v-if="event.type === 'Keynote'" class="col-3">
              <img class="company__logo" :src="getImage" alt />
              <span class="company__name">{{ event.company }}</span>
            </div>
            <div :class="isKeynote">
              <h5>
                <strong>{{ event.title }}</strong>
              </h5>

              <span v-if="$route.params.language === 'pt'">
                <div v-if="event.slot.description_pt">
                  <h6 v-if="event.slot.description_pt.length > 3">Sinopse:</h6>
                  <p v-if="event.slot.description_pt.length > 3">{{ event.slot.description_pt }}</p>
                </div>
                <div v-if="event.slot.highlights_pt">
                  <h6 v-if="event.slot.highlights_pt.length > 3">Overview:</h6>
                  <p v-if="event.slot.highlights_pt.length > 3">{{ event.slot.highlights_pt }}</p>
                </div>
                <p v-if="event.slot.descsrition_pt === '*'">{{ event.slot.description_pt }}</p>
              </span>
              <span v-else>
                <div v-if="event.slot.description_en">
                  <h6 v-if="event.slot.description_en.length > 3">Synopsis:</h6>
                  <p v-if="event.slot.description_en.length > 3">{{ event.slot.description_en }}</p>
                </div>
                <div v-if="event.slot.highlights_en">
                  <h6 v-if="event.slot.highlights_en.length > 3">Overview:</h6>
                  <p v-if="event.slot.highlights_en.length > 3">{{ event.slot.highlights_en }}</p>
                </div>
                <p v-if="event.slot.descsrition_en === '*'">{{ event.slot.description_en }}</p>
              </span>

              <div v-for="(speaker, index) in coordinators" :key="index+1">
                <speaker :speaker="speaker" :coordinator="true"></speaker>
              </div>
              <div v-for="(speaker, index) in mediators" :key="index+1">
                <speaker :speaker="speaker" :mediator="true"></speaker>
              </div>
              <div v-for="(speaker, index) in speakers" :key="index+2">
                <speaker :speaker="speaker"></speaker>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer tags" v-if="event.slot.tags">
          <h6>Tags:</h6>
          <p>{{ event.slot.tags }}</p>
        </div>
        <div v-if="this.event.slot.tracks.length > 0 " class="modal-footer">
          <h6>Tracks:</h6>
          <p>
            <span
              class="badge badge-info"
              v-for="(track, index) in this.event.slot.tracks"
              :key="index"
            >
              <span v-if="$route.params.language === 'pt'">{{ track.name_pt }}</span>
              <span v-else>{{ track.name_en }}</span>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../main";
import Speaker from "./Speaker.vue";
export default {
  data() {
    return {
      event: undefined
    };
  },
  computed: {
    speakers() {
      if (this.event.slot.keynote) {
        return this.event.slot.keynote;
      }
      return false;
    },
    coordinators() {
      if (this.event.slot.coordinators) {
        return this.event.slot.coordinators;
      }
      return false;
    },
    mediators() {
      if (this.event.slot.mediators) {
        return this.event.slot.mediators;
      }
      return false;
    },
    getBgColor() {
      if (this.event.type_color) {
        return this.event.type_color;
      }
      return null;
    },
    getImage() {
      const imgUrl =
        "https://px3-static.sfo2.cdn.digitaloceanspaces.com/futurecom19/";
      if (this.event.logo) {
        return imgUrl + this.event.logo;
      }
      return null;
    },
    isKeynote() {
      return {
        "col-9": this.event.type === "Keynote",
        "col-12": this.event.type !== "Keynote"
      };
    }
  },
  created() {
    eventBus.$on("selectEvent", eventSelected => {
      this.event = eventSelected;
    });
  },
  components: {
    Speaker
  }
};
</script>
<style lang="scss" scoped>
.modal-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap-reverse;
  .close {
    margin-bottom: 0px;
  }
}
.event__type {
  color: #fff;
  display: flex;
  max-height: 34px;
  font-size: 14px;
  font-weight: bold;
  padding: 6px 9px;
  margin: 0 12px 0 0;
  border-radius: 6px;
}
.company {
  &__name {
    width: 100%;
    display: inline-block;
    text-align: center;
    font-weight: bold;
  }
  &__logo {
    width: 80%;
    display: block;
    margin: 0 auto;
  }
}
.modal-body {
  p {
    font-size: 12px;
  }
}
.modal-footer {
  &.tags {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  h6 {
    margin: 0;
  }
  p {
    width: 100%;
    margin: 0 0 0 12px;
  }
  span.badge {
    margin: 0 3px;
  }
}
.palestrantes {
  padding: 3px 6px;
  .palestrante {
    display: inline-block;

    &__img {
      display: none;
      img {
        width: 100%;
        border-radius: 6px;
      }
    }
    &__name {
      height: 20px;
      color: #666;
      font-size: 9px;
      line-height: 9px;
      padding: 3px 0;
      font-weight: bold;
      overflow: hidden;
      span {
        width: 100%;
        display: inline-block;
        font-size: 7px;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/event/EventInfo.vue